var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeletePopupIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 78,
    height: 78,
    rx: 39,
    fill: "#EF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.917 56.7507L39.0003 20.334L60.0837 56.7507H17.917ZM24.5295 52.9173H53.4712L39.0003 28.0007L24.5295 52.9173ZM39.0003 51.0007C39.5434 51.0007 39.9986 50.817 40.3659 50.4496C40.7333 50.0823 40.917 49.627 40.917 49.084C40.917 48.5409 40.7333 48.0857 40.3659 47.7184C39.9986 47.351 39.5434 47.1673 39.0003 47.1673C38.4573 47.1673 38.0021 47.351 37.6347 47.7184C37.2673 48.0857 37.0837 48.5409 37.0837 49.084C37.0837 49.627 37.2673 50.0823 37.6347 50.4496C38.0021 50.817 38.4573 51.0007 39.0003 51.0007ZM37.0837 45.2507H40.917V35.6673H37.0837V45.2507Z",
    fill: "#F4F6F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePopupIcon);
export default __webpack_public_path__ + "static/media/DeletePopupIcon.59a7e03fa00f15fd65ff5de6b6dff3f0.svg";
export { ForwardRef as ReactComponent };